import { Fragment, FunctionalComponent, h } from 'preact';

import { MyNotesModel } from 'common/data/my-notes/model';
import { MyAccountEmptyListComponent } from 'common/module/my-account/empty-list/component';
import { MyAccountListTypeEnum } from 'common/module/my-account/list-type.enum';
import { MyNotesNoteComponent } from 'common/module/my-notes/note/component';
import { preactDynamicComponent } from 'common/module/preact/dynamic/component';
import { PropertyListTemplatePropsInterface } from 'common/module/property/list/template-props.interface';
import { MyAccountEmptyListViewStoreService } from 'common/service/my-account-empty-list-view-store/service';
import { MyAccountStoreService } from 'common/service/my-account-store/service';
import { PropertyCardTemplate } from 'desktop/module/property/card/template';

const PropertyNoteComponent = preactDynamicComponent(
  ((props) =>
    !!props.model && (
      <MyNotesNoteComponent
        onClickDelete={(model) => MyAccountStoreService().deleteNote(model.id)}
        model={props.model}
        listType={props.listType}
      />
    )) as FunctionalComponent<{
    id: string;
    model: MyNotesModel;
    listType: MyAccountListTypeEnum;
  }>
);

export const MyAccountPropertyListTemplate: FunctionalComponent<PropertyListTemplatePropsInterface> = (props) => (
  <div>
    {!props.properties.length ? (
      <div className='usernoresult'>
        <MyAccountEmptyListComponent viewStore={MyAccountEmptyListViewStoreService()} />
      </div>
    ) : (
      <Fragment>
        {props.properties.length > 0 && (
          <ul className={`card-list ${props.disabled ? 'card-list--disabled' : ''}`}>
            {props.properties.map((item, index) => (
              <li className='card-list__item'>
                <PropertyCardTemplate
                  {...item}
                  showActions={!item.property.is_expired && item.showActions}
                  showDeleteButton={
                    item.property.is_expired && props.listType !== MyAccountListTypeEnum.notes
                      ? true
                      : item.showDeleteButton
                  }
                  onComponentDidMount={(element: HTMLElement) => item.onCreateTemplate(element, index)}
                />

                <PropertyNoteComponent
                  viewStore={MyAccountStoreService()}
                  mapState={() => ({
                    id: item.property.id,
                    model: MyAccountStoreService().getState().notes[item.property.id],
                    listType: props.listType,
                  })}
                />
              </li>
            ))}
          </ul>
        )}
      </Fragment>
    )}
  </div>
);
